export default __webpack_public_path__ + "static/media/prachi-tank-resume.aeb4f5dd.pdf";